import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'cm-case-details-section',
  standalone: true,
  imports: [DatePipe],
  templateUrl: './case-details-section.component.html',
  styleUrl: './case-details-section.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CaseDetailsSectionComponent {
  public readonly caseData = input.required<{
    caseNumber: string;
    createdBy: string;
    dueDate: Date | null;
    createdDate: Date;
    caseType: string;
    category: string;
  }>();
}
